setTimeout(function () {
  const $ = window.jQuery;
  //initCarousel();

  $(document).on('click', '.rebuy-button', function (e) {
    e.preventDefault();

    var dataKey = $(this).data("cart-item-key");
    var dataSelling = $(this).data("selling-plan");
    var dataQty = $(this).data("product-qty");

    updateChangeCart(dataKey, dataSelling, dataQty);
    return false;
  });

  $(document).on('change', '.rebuy-cart__flyout-item-subscription .rebuy-select', function (e) {
    e.preventDefault();

    var dataKey = $(this).data("cart-item-key");
    var dataSelling = $(this).val();
    var dataQty = $(this).data("product-qty");

    updateChangeCart(dataKey, dataSelling, dataQty);
    return false;
  });

  $(document).ready(function () {
    $('.skio-test').parent().parent().css('z-index', 2);
  });

  $(document).on("click", '.js-drawer-open-cart', function (e) {
    renderSelect();
  });

  $('.form-group-check input').each(function (index) {
    let $this = $(this);
    let price = (parseInt($this.data('selling-price')) / 100).toFixed(2);
    let oldPrice = (parseInt($this.data('compare-price')) / 100).toFixed(2);
    let percentage = $this.data('percentage');
    let parent = $this.closest('.AddToCartForm ');
    let contentPrice = parent.find('.gf_product-price');
    let comparePrice = parent.find('.gf_product-compare-price');
    let porcLabel = `<span>Save ${percentage}%</span>`;

    if ($this.is(':checked')) {
      parent.addClass('active-selling');

      contentPrice.html(`$${price} ${porcLabel}`);
      contentPrice.data('price', `$${price}`);

      comparePrice.text(`$${oldPrice}`);
      comparePrice.data('price-compare-at', `$${oldPrice}`);
      comparePrice.show();
    }
  });

  $(document).on('change', '.form-group-check input', function () {
    $this = $(this);
    let price = (parseInt($this.data('selling-price')) / 100).toFixed(2);
    let oldPrice = (parseInt($this.data('compare-price')) / 100).toFixed(2);
    let percentage = $this.data('percentage');
    let parent = $this.closest('.AddToCartForm ');
    let contentPrice = parent.find('.gf_product-price');
    let comparePrice = parent.find('.gf_product-compare-price');
    let porcLabel = `<span>Save $${percentage}</span>`;

    if ($this.is(':checked')) {
      parent.addClass('active-selling');

      contentPrice.html(`$${price} ${porcLabel}`);
      contentPrice.data('price', `$${price}`);

      comparePrice.text(`$${oldPrice}`);
      comparePrice.data('price-compare-at', `$${oldPrice}`);
      comparePrice.show();
    } else {
      parent.removeClass('active-selling');

      contentPrice.text(`$${oldPrice}`);
      contentPrice.data('price', `$${oldPrice}`);
      comparePrice.hide();
    }
  })
}, 2000);

const updateChangeCart = async (product_id, selling_plan, qty) => {
  let formData = {
    'id': product_id,
    'selling_plan': selling_plan,
    'quantity': qty
  };

  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {

      if (response) {
        drawer.init();

        if (window.location.href.includes("cart")) {
          location.reload();
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

var initCarousel = function () {
  const bundleCarousel = $('.bundle-carousel');
  if (bundleCarousel && (typeof owlCarousel === 'function')) {
    bundleCarousel.owlCarousel({
      loop: false,
      margin: 16,
      nav: false,
      items: 2,
      dots: false,
    });
  }
}